"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var faSpinnerThird_1 = require("@fortawesome/pro-solid-svg-icons/faSpinnerThird");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var SPINNER_CLASS = "flex flex-grow-0 flex-shrink";
var Spinner = function (_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? "1x" : _b;
    return ((0, jsx_runtime_1.jsx)("p", __assign({ className: [className !== null && className !== void 0 ? className : "", SPINNER_CLASS].join(" ") }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "animate-spin" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faSpinnerThird_1.faSpinnerThird, size: size }, void 0) }), void 0) }), void 0));
};
exports.Spinner = Spinner;
